import { ECommercePage } from "../features/e-commerce/pages/e-commerce"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function EcommerceDashboard() {
  return (
    <DashboardLayout>
      <ECommercePage />
    </DashboardLayout>
  )
}
